import { parse } from 'qs';

export default (query, options = {}) =>
  parse(query, { ...options, ignoreQueryPrefix: true });
